// Pannello "commesse di oggi" dell'hero della landing gestionale spurghisti.
// Convertito da: public/proposta/assets/js/gestionale-spurghi.js
//
// Stessa filosofia del flusso operativo di Cleve (cleve-2026.js): reveal
// sequenziale, pausa, reset, loop. Qui in più il pannello racconta un
// micro-evento della giornata — una commessa che passa in carico e il contatore
// dei formulari che avanza — prima di ripartire.
//
// Il bundle public-2026.js carica tutti i file di questa cartella su ogni pagina:
// senza .jobs-panel nel DOM lo script esce subito.
//
// Progressive enhancement: senza JS il pannello resta nel suo stato finale,
// statico e leggibile. La classe .is-armed viene aggiunta solo qui, ed è quella
// che abilita gli stati iniziali "nascosti" in _gestionale-2026.scss.
//
// Nessun testo hardcodato: le etichette di stato e i valori del contatore
// arrivano dai data-attribute del markup (_hero-visual-gestionale-2026.blade.php),
// che li prende dal file di lingua — altrimenti in inglese resterebbero italiani.
(function () {
    'use strict';

    var panel = document.querySelector('.jobs-panel');
    if (!panel) return;

    var rows     = Array.prototype.slice.call(panel.querySelectorAll('.jobs-row'));
    var firBox   = panel.querySelector('.jobs-fir');
    var barEl    = panel.querySelector('[data-jobs-bar]');
    var firEl    = panel.querySelector('[data-jobs-fir]');
    var flipRow  = panel.querySelector('[data-jobs-flip]');
    var flipPill = panel.querySelector('[data-jobs-status]');
    if (!rows.length || !barEl || !firEl || !firBox) return;

    var FIR_FROM = firBox.getAttribute('data-jobs-fir-from') || '9/12';
    var FIR_TO   = firBox.getAttribute('data-jobs-fir-to')   || '10/12';
    var BAR_FROM = firBox.getAttribute('data-jobs-bar-from') || '75%';
    var BAR_TO   = firBox.getAttribute('data-jobs-bar-to')   || '83.3%';

    var LABEL_FROM = flipPill ? flipPill.getAttribute('data-jobs-label-from') : '';
    var LABEL_TO   = flipPill ? flipPill.getAttribute('data-jobs-label-to')   : '';

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return;   /* stato finale già nel markup: niente da fare */

    panel.classList.add('is-armed');

    var STAGGER   = 150;   /* distanza tra una riga e l'altra           */
    var BAR_DELAY = 320;   /* attesa dopo l'ultima riga prima dei FIR   */
    var FLIP_WAIT = 2600;  /* quanto resta fermo prima del micro-evento */
    var HOLD      = 3400;  /* quanto resta sullo stato finale           */
    var OUT_STEP  = 80;    /* stagger di uscita, dal basso verso l'alto */
    var OUT_FADE  = 560;   /* durata della dissolvenza in uscita        */

    var timers = [];
    function later(fn, ms) { timers.push(setTimeout(fn, ms)); }
    function clearAll() { timers.forEach(clearTimeout); timers = []; }

    /* Riporta i contenuti allo stato di partenza SENZA transizioni: va chiamata
       solo a righe già invisibili, altrimenti si vede la pill tornare indietro. */
    function resetState() {
        panel.classList.add('is-resetting');

        rows.forEach(function (r) { r.classList.remove('is-in', 'is-flash'); });
        firBox.classList.remove('is-in');
        barEl.style.width = '0%';
        firEl.textContent = FIR_FROM;
        if (flipPill) {
            if (LABEL_FROM) flipPill.textContent = LABEL_FROM;
            flipPill.classList.remove('jobs-status--corso');
            flipPill.classList.add('jobs-status--attesa');
        }

        void panel.offsetHeight;   /* reflow: il nuovo stato è già quello vecchio */
        panel.classList.remove('is-resetting');
    }

    /* Uscita: prima il blocco formulari (è l'ultimo arrivato), poi le righe dal
       basso verso l'alto, e solo alla fine il ripristino dei contenuti. */
    function cycleOut(done) {
        var seq = [firBox].concat(rows.slice().reverse());
        seq.forEach(function (el, i) {
            later(function () { el.classList.remove('is-in'); }, i * OUT_STEP);
        });
        later(function () { resetState(); done(); }, (seq.length - 1) * OUT_STEP + OUT_FADE);
    }

    function play() {
        rows.forEach(function (row, i) {
            later(function () { row.classList.add('is-in'); }, i * STAGGER);
        });

        var afterRows = rows.length * STAGGER + BAR_DELAY;

        /* Blocco formulari: entra dopo le righe, poi la barra si riempie fino
           allo stato di partenza. */
        later(function () { firBox.classList.add('is-in'); }, afterRows);
        later(function () { barEl.style.width = BAR_FROM; }, afterRows + 220);

        /* Micro-evento: la commessa da assegnare passa in carico e il contatore
           dei formulari avanza di uno. */
        later(function () {
            if (flipRow) flipRow.classList.add('is-flash');
            if (flipPill) {
                if (LABEL_TO) flipPill.textContent = LABEL_TO;
                flipPill.classList.remove('jobs-status--attesa');
                flipPill.classList.add('jobs-status--corso');
            }
            firEl.textContent = FIR_TO;
            barEl.style.width = BAR_TO;
        }, afterRows + FLIP_WAIT);

        /* Pausa sullo stato finale, poi uscita e nuovo giro */
        later(function () {
            cycleOut(function () { later(play, 420); });
        }, afterRows + FLIP_WAIT + HOLD);
    }

    function start() {
        clearAll();
        resetState();
        requestAnimationFrame(function () { later(play, 400); });
    }

    /* Il pannello è above-the-fold: si parte a font caricati, come la mappa
       flusso di Cleve, senza dipendere da IntersectionObserver. */
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(start);
    } else {
        start();
    }

    /* Fuori dallo schermo il loop si ferma: niente lavoro inutile. */
    document.addEventListener('visibilitychange', function () {
        if (document.hidden) { clearAll(); } else { start(); }
    });
})();
